<template>
  <div>
    <a-select
      style="margin-bottom: 10px;"
      v-model="form['type' + nameField]"
      allowClear
      placeholder="Choose"
      @change="setRangeDate()"
    >
      <a-select-option value="YEAR">
        YEAR
      </a-select-option>
      <a-select-option value="MONTH">
        MONTH
      </a-select-option>
      <a-select-option value="DATE">
        DATE
      </a-select-option>
    </a-select>
    <a-range-picker
      v-if="form['type' + nameField] === 'DATE'"
      v-model="form['range' + nameField]"
      style="width: 100%;"
      :show-time="false"
      format="DD/MM/YYYY"
      @change="onChangeRange"
    />
    <a-month-picker
      v-else-if="form['type' + nameField] === 'MONTH'"
      style="width: 100%;"
      placeholder="Select month"
      v-model="form['month' + nameField]"
      :allowClear="false"
      :value="
        form['month' + nameField] ? moment(form['month' + nameField]) : null
      "
      format="MM/YYYY"
      @change="onChangeMonth"
    />
    <a-date-picker
      v-else-if="form['type' + nameField] === 'YEAR'"
      style="width: 100%;"
      placeholder="Choose year"
      mode="year"
      format="YYYY"
      :value="
        form['year' + nameField] ? moment(form['year' + nameField]) : null
      "
      @change="
        (value) => {
          setForm('year' + nameField, value);
          onChangeYear();
        }
      "
      @panelChange="
        (value) => {
          setForm('year' + nameField, value);
          onChangeYear();
        }
      "
    />
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    nameField: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    setForm: {
      type: Function,
      default: () => {},
    },
    onChoose: {
      type: Function,
      default: () => {},
    },
  },
  methods: {
    moment,
    setRangeDate(range = []) {
      if (range?.length > 0) {
        const [startDate, endDate] = range;
        this.setForm(this.nameField, {
          start: moment(startDate).startOf("days"),
          end: moment(endDate).endOf("days"),
        });
      } else {
        this.setForm(this.nameField, undefined);
      }
    },
    runCallBack() {
      if (this.onChoose && typeof this.onChoose === "function") {
        this.onChoose();
      }
    },
    onChangeYear() {
      if (this.form["type" + this.nameField] === "YEAR") {
        if (this.form["year" + this.nameField]) {
          this.setRangeDate([
            moment(this.form["year" + this.nameField]).startOf("year"),
            moment(this.form["year" + this.nameField]).endOf("year"),
          ]);
        } else {
          this.setRangeDate();
        }

        this.runCallBack();
      }
    },
    onChangeMonth() {
      if (this.form["type" + this.nameField] === "MONTH") {
        if (this.form["month" + this.nameField]) {
          this.setRangeDate([
            moment(this.form["month" + this.nameField]).startOf("month"),
            moment(this.form["month" + this.nameField]).endOf("month"),
          ]);
        } else {
          this.setRangeDate();
        }
        this.runCallBack();
      }
    },
    onChangeRange() {
      if (this.form["type" + this.nameField] === "DATE") {
        this.setRangeDate();
        this.runCallBack();
      }
    },
  },
};
</script>
